import React from 'react';
import withStyles from '@mui/styles/withStyles';
import ErrorImg from '../../assets/images/error.svg';

const styles = theme => ({
    mainDiv:{
        width:'73%',
        marginTop:'10px',
        alignSelf:'center',
        display:'flex',
        flexDirection:'column',
        justifyContent:'center',
        alignItems:'center',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
        border:'1px solid red',
        padding:'20px 0px',
        marginBottom:'10px',
        borderRadius:'8px',
        marginBottom:"10px",
        backgroundColor:'#fff',
        [theme.breakpoints.between('xs','md')]: {
            width:'100%'
		},
        "& img":{
            width:'80px'
        }
    },

    spanText:{
        fontWeight:'bold',
        fontFamily:"'Poppins', sans-serif",
        color: '#FF5454',
        textAlign:'center',
        width:'80%'
    },

    errorDiv:{
        width:'80%',
        backgroundColor:'#FF5454',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        marginTop:'10px',
        padding:'5px',
        "& span":{
            fontWeight:'bold',
            fontFamily:"'Cairo', sans-serif",
            color: '#fff',
            textAlign:'center',
        }
    }
})

class PaymentError extends React.Component {

    render() {
        const { classes } = this.props;
    return(
        <div className={classes.mainDiv}>
            <img src={ErrorImg} alt='error' />
            <span className={classes.spanText}>Something Wrong happened, payment is not successful, Please review the card data and balance and try again</span>
            <div className={classes.errorDiv}>
                <span>حدث  خطأ و عملية الدفع لم تتم بنجاح</span>
                <span>ارجو مراجعة بيانات الكرت و المحاولة مرة اخري</span>
            </div>
        </div>
    )}
}

export default withStyles(styles)(PaymentError);